/* eslint-disable react/prop-types */
import React, { useId } from 'react';

import { type NextPage } from 'next';
import { type NextFont } from 'next/dist/compiled/@next/font';

import { PageContainer, Editions } from '../components/index';
import { type IEditionsProps } from '../components/Editions';
import { Loading } from '../components/util';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useGetCelebratedTechiesQuery, useGetWinnersQuery } from '../utils/services/EditionsApiConnection';

// eslint-disable-next-line react/prop-types
const Celebrated: NextPage<{ inter: NextFont }> = ({ inter }) => {
  // const [celebratedTechies, setCelebratedTechies] = useState<IEditionsProps[]>(
  //   []
  // );
  // const { data, isLoading } = useGetCelebratedTechiesQuery({}) as {
  //   data: { data: IEditionsProps[] }
  //   isLoading: boolean
  // };
  const { data: winnersData, isLoading: isWinnersLoading } = useGetWinnersQuery(
    null
  );
  // useEffect(() => {
  //   if (data?.data) {
  //     setCelebratedTechies(data.data);
  //   }
  // }, [data]);
  return (
    <PageContainer>
      {isWinnersLoading
        ? (
        <Loading className="my-[40vh]" />
          )
        : (
        <div
          className={`content mt-12 flex flex-col items-center ${inter.className}`}
        >
          <h1 className="text-center text-2xl font-bold text-[#0c0114] lg:text-3xl">
            The Global Tech Heroes
          </h1>
          <p className="text-center text-2xl font-medium text-[#808080] lg:text-xl">
            Exploring Our Winners
          </p>
          <div className="flex flex-col gap-6 mt-2">
            <div className="grid grid-cols-1 gap-12 p-6 md:grid-cols-2 md:p-8 lg:grid-cols-4 lg:p-12">
              {winnersData?.data?.map((props: IEditionsProps) => (
                <Editions key={props.Id} {...props} />
              ))}
            </div>
            {/* <div>
              <h2 className="text-center text-xl font-medium text-[#0c0114] lg:text-3xl">
                The Notable Contestants
              </h2>
              <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:p-8 lg:grid-cols-3 lg:p-12">
                {celebratedTechies.map((props) => (
                  <Editions key={props.Id} {...props} />
                ))}
              </div>
            </div> */}
          </div>
        </div>
          )}
    </PageContainer>
  );
};

export default Celebrated;
